import HeroImage from "./hero-swirl.png";
import { Box, Stack, StackProps, useTheme } from "@mui/material";

/**
 * Full-bleed brand-color container with the wave graphic, used as the shell
 * for full-page states (access denied/pending, not found, errors) — ported
 * from twosion-ui's HeroSwirlContainer, which twosion-ui's AppErrorPage and
 * PageNotFound pages are both built on. Same shell, same asset, so these
 * states look like they belong to the same product family.
 */
export function HeroSwirlContainer({ children, ...props }: StackProps) {
  const { palette } = useTheme();

  return (
    <Stack className="hero-swirl" position="relative" bgcolor={palette.background.brand} {...props}>
      <Box
        component="img"
        alt="Wave"
        src={HeroImage}
        sx={{
          width: "100%",
          position: "absolute",
          bottom: 0,
          transform: "translateY(35%)",
          pointerEvents: "none",
        }}
      />
      {children}
    </Stack>
  );
}
